















































// decoradores
import {Component, Emit, Prop, Vue} from "vue-property-decorator";
// tipos
import {HeadersDataTable} from "@/typings/vuetify/vDataTable";
import {EstadoUsuario, Usuario} from "@/typings/store/plugins/easyFirestore/usuarios";
import {ItemsTablaUsuarios} from "@/typings/components/usuarios/tabla";
import "@/helpers/extensions";

@Component
export default class TablaUsuarios extends Vue {
  @Prop() readonly opciones!: boolean;
  @Prop() readonly search!: string;
  @Prop() readonly usuarios!: Array<Usuario>;

  headerProps = {
    sortIcon: "mdi-chevron-down"
  }

  get headers(): HeadersDataTable {
    return [
      {text: "Estado", value: "estado", sortable: false},
      {text: "Nombre", value: "nombre"},
      {text: "RUT", value: "rut"},
      {text: "Rol", value: "tipo"},
      {text: "Correo", value: "email"},
      {text: "Ingreso", value: "fecha"},
      {text: "Acciones", value: "opciones", sortable: false}
    ];
  }

  get items(): ItemsTablaUsuarios {
    return this.usuarios.map((usuario) => {
      const nombre = usuario.nombre;
      const rut = usuario.rut;
      const email = usuario.email;
      const tipo = usuario.tipo;
      const fecha = usuario.fecha?.toDate().format("DD/MM/YYYY") ?? "";
      return {
        nombre,
        rut,
        email,
        tipo,
        fecha,
        data: usuario,
      };
    });
  }

  actualizarEstado(item: Usuario): void {
    let estado: EstadoUsuario;
    item.estado === 'libre' ? estado = 'bloqueado' : estado = 'libre';
    item.estado = estado;
    this.onCambiarEstado(item);
  }

  etiquetaTipo(tipo: string): string {
    const roles: Record<string, string> = {
      admin: "Administrador",
      supervisor: "Supervisor",
      relator: "Relator",
      cliente: "Cliente",
      operador: "Operador",
      administrador_locales: "Administrador de locales",
      gerente_general: "Gerente general",
      gerente_operaciones: "Gerente de operaciones",
      gerente_comercial: "Gerente comercial",
    };
    return roles[tipo] || tipo;
  }

  onFila(item: { data: Usuario }, event: MouseEvent): void {
    const destino = event.target as HTMLElement | null;
    if (destino && destino.closest("button, .v-btn, a")) return;
    this.onAbrirInfo(item.data);
  }

  @Emit("cambiar-estado")
  onCambiarEstado(usuario: Usuario): Usuario {
    return usuario;
  }

  @Emit("abrir-info")
  onAbrirInfo(usuario: Usuario): Usuario {
    return usuario;
  }

  @Emit("abrir-editar")
  onAbrirEditar(usuario: Usuario): Usuario {
    return usuario;
  }

  @Emit("abrir-eliminar")
  onAbrirEliminar(usuario: Usuario): Usuario {
    return usuario;
  }
}
